import {doppeActionTypeDefineViewerMetadata} from "../../client-server-common/doppe-action-types/doppe-action-type";
import React from "react";
import {doppeActionTypeHoppEvents} from './doppe-action-type-hopp-events';

export const doppeActionTypeHoppEventsViewer = doppeActionTypeDefineViewerMetadata(doppeActionTypeHoppEvents, {

    loadViewerComponents: async () => {
        return {
            DoppeActionTypeHoppEventsWidget: (await import(
                './doppe-action-type-hopp-events-widget/doppe-action-type-hopp-events-widget'
                )).DoppeActionTypeHoppEventsWidget
        }
    },

    renderWidget: (renderProps, viewerComponents) => {

        const {
            DoppeActionTypeHoppEventsWidget
        } = viewerComponents;

        return (
            <DoppeActionTypeHoppEventsWidget
                {...renderProps}
            />
        );
    }
});